import React from 'react';
import TourCard from './Multitour';
import { Row, Col } from "reactstrap";

const Tours = ({ currentTours, navigateToTourDetails }) => {
  return (
    <Row>
      {currentTours.map((tour, index) => (
        <Col key={index} sm="12" md="6" lg="4" className="mb-4">
          <TourCard tour={tour} navigateToTourDetails={navigateToTourDetails} />
        </Col>
      ))}
    </Row>
  );
};

export default Tours;
